import React, {useEffect, useState} from "react";
import useAuth from "../../../hooks/useAuth";
import {getUserApi} from "../../../services/User/user";

export default function MyAccountWorker(){
    const { auth } = useAuth()
    const role = auth ? auth.primaryUser.role : null
    const { logout } = useAuth()
    const [loading, setLoading] = useState(true)
    const [userData, setUserData] = useState(null)
    const [filteredRegions, setFilteredRegions] = useState([])
    const [filteredMunicipalities, setFilteredMunicipalities] = useState([])


    // Llamamos a la API para obtener los datos del usuario
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        getClient()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const getClient = async () => {
            getUserApi({ id: auth.primaryUser.idUser }).then(response => { 
            if (response.status) {
                setUserData({ id: response.data.data.id, email: response.data.data.email, phone: response.data.data.phone, info: response.data.data.info, service: response.data.data.service, zone: response.data.data.zone })
                setLoading(false);
                setFilteredRegions(response.data.data.zone.filter(({ idRegion }, index) => !response.data.data.zone.map(o => o.idRegion).includes(idRegion, index + 1)))
                setFilteredMunicipalities(response.data.data.zone.filter(({ idMunicipality }, index) => !response.data.data.zone.map(o => o.idMunicipality).includes(idMunicipality, index + 1)))

            }
            setLoading(false)
        }).catch(error => {
            console.error(error)
            setLoading(false)
        })
    }

    if (loading) return "";

    return (
        <div className="col-lg-9">
            <div className="card mb-3 mb-lg-5">
                <div className="card-header">
                    <h5 className="card-header-title">
                        Datos Personales
                    </h5>
                </div>

                <div className="card-body">
                    <form>
                        <div className="row mb-4">
                            <label htmlFor="firstNameLabel" className="col-sm-3 col-form-label form-label">Nombre completo</label>

                            <div className="col-sm-9">
                                <div className="input-group">
                                    <input type="text" className="form-control" name="firstName" id="firstNameLabel" placeholder={auth.primaryUser.name} aria-label={auth.primaryUser.name} value={auth.primaryUser.name} disabled />
                                    <input type="text" className="form-control" name="lastName" id="lastNameLabel" placeholder={auth.primaryUser.surnames} aria-label={auth.primaryUser.surnames} value={auth.primaryUser.surnames} disabled />
                                </div>
                            </div>
                        </div>
                        <div className="row mb-4">
                            <label htmlFor="emailLabel" className="col-sm-3 col-form-label form-label">Email</label>

                            <div className="col-sm-9">
                                <input type="email" className="form-control" name="email" id="emailLabel" placeholder={userData.email} aria-label={userData.email} value={userData.email} disabled />
                            </div>
                        </div>
                        <div className="row mb-4">
                            <label htmlFor="emailLabel" className="col-sm-3 col-form-label form-label">Teléfono</label>

                            <div className="col-sm-9">
                                <input type="email" className="form-control" name="email" id="phoneLabel" placeholder={userData.phone} aria-label={userData.phone} value={userData.phone} disabled />
                            </div>
                        </div>
                        <div className="row mb-4">
                            <label htmlFor="info" className="col-sm-3 col-form-label form-label" >{role === "ROLE_CLIENT" ? "Dirección" : "Observaciones"}</label>

                            <div className="col-sm-9">
                                <div className="input-group">
                                    <textarea className="form-control" name="info" id="info" style={{ resize: "none", }} value={userData.info} disabled></textarea>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-4">
                            <label htmlFor="serviceLabel" className="col-sm-3 col-form-label form-label">Servicios {role === "ROLE_CLIENT" ? "contratados" : "asignados"}</label>

                            <ul className="col-sm-9 col-form-label">
                                {userData.service.map(service => <li key={service.id}>{service.name}</li>)}
                            </ul>
                        </div>

                        <div className="row mb-4">
                            <label htmlFor="zoneLabel" className="col-sm-3 col-form-label form-label">Zonas de trabajo Comarca</label>
                            <ul className="col-sm-9 col-form-label">
                                {filteredRegions.map(filReg => <li key={filReg.id}>{filReg.nameRegion}</li>)}
                            </ul>

                        </div>
                        <div className="row mb-4">
                            <label htmlFor="zoneLabel" className="col-sm-3 col-form-label form-label">Zonas de trabajo Población</label>

                            <ul className="col-sm-9 col-form-label">
                                {filteredMunicipalities.map(filMun => <li key={filMun.id}>{filMun.nameMunicipy}</li>)}
                            </ul>


                        </div>

                    </form>
                </div>
            </div>
        </div>
    )
}